import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerMemberManagementDashboardType } from "../../looker-member-management-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-invoice-aging-report",
  templateUrl: "./invoice-aging-report.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceAgingReportComponent {
filters: string[] = ["Projects"];
dashboardType = LookerMemberManagementDashboardType.Invoice_Aging_Report;
hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID, HideFilters.CUSTOMER_NAME2];
}
